import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16 13c-1.7 0-3-1.3-3-3V5.5c0-2.2-1.7-4-4-4.5V0H7v1.1c-2.3.4-4 2.2-4 4.4V10c0 1.7-1.3 3-3 3v1h6.7c-.1.2-.1.4-.1.6 0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4 0-.2 0-.4-.1-.6H16v-1zm-9-1.4L4.6 8.4l.7-.7L7 8.8l3.8-3.4.8.8L7 11.6z" fill="#A6A6A6" /></svg>;